import { GeneralHelpConst } from '@/app/_presentation/shared/layout/_config/layout.const';
import { Router } from '@angular/router';

let lastScrollRequestId = 0;

export function goToFragmentHelp(
  router: Router,
  identifier: string,
  opts: {
    isDesktop: boolean;
    isGeneralRoute: boolean;
    offset?: number;
    containerId?: string;
    onStart?: () => void;
    onEnd?: () => void;
  }
): void {
  const currentRequestId = ++lastScrollRequestId;
  const { isDesktop, isGeneralRoute, offset = 100, containerId = GeneralHelpConst.RefScroll, onStart, onEnd } = opts;

  if (onStart) onStart();

  router.navigate([], { fragment: identifier, queryParamsHandling: 'preserve', skipLocationChange: true }).then((success) => {
    if (success === false) {
      if (onEnd) onEnd();
      return;
    }
    const tryScroll = (tries = 0) => {
      if (currentRequestId !== lastScrollRequestId) {
        if (onEnd) onEnd();
        return;
      }
      if (tries > 50) {
        if (onEnd) onEnd();
        return;
      }
      const targetEl = document.getElementById(identifier);
      if (!targetEl) {
        requestAnimationFrame(() => tryScroll(tries + 1));
        return;
      }
      const host: HTMLElement | Window = isDesktop && !isGeneralRoute ? document.getElementById(containerId) : window;

      if (host instanceof Window) {
        const y = targetEl.getBoundingClientRect().top + host.scrollY - offset;
        host.scrollTo({ top: y, behavior: 'auto' });
      } else if (host) {
        const hostRect = host.getBoundingClientRect();
        const targetRect = targetEl.getBoundingClientRect();
        const y = targetRect.top - hostRect.top + host.scrollTop;
        host.scrollTo({ top: y, behavior: 'auto' });
      }

      if (onEnd) {
        setTimeout(() => onEnd(), 500);
      }
    };
    requestAnimationFrame(() => tryScroll());
  });
}
